import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Logo.css';

interface ILogoSize {
  phone: number;
  tablet: number;
  desktop: number;
}

interface ILogoProps {
  img: string;
  size: number | ILogoSize;
}

export const Logo: React.FC<ILogoProps> = ({ img, size }) => {
  const renderContent = React.useCallback(
    (logoSize: number) => {
      return (
        <div
          className={styles['container']}
          style={{
            backgroundImage: `url("${img}")`,
            width: logoSize,
            height: logoSize,
          }}
        />
      );
    },
    [img],
  );

  if (typeof size === 'number') {
    return renderContent(size);
  }

  return (
    <>
      <Responsive phone>{renderContent(size.phone)}</Responsive>
      <Responsive tablet>{renderContent(size.tablet)}</Responsive>
      <Responsive desktop>{renderContent(size.desktop)}</Responsive>
    </>
  );
};
